export const FORFEO_EXPLORE_URL =
  import.meta.env.VITE_FORFEO_EXPLORE_URL || "https://forfeoexplore.com";

export const FORFEO_COM_URL =
  import.meta.env.VITE_FORFEO_COM_URL || "https://forfeo.com";

export type CrossUniverseSource =
  | "home"
  | "header"
  | "footer"
  | "carte_cadeau"
  | "combo"
  | "last_call"
  | "dashboard"
  | "admin"
  | "email"
  | "unknown";

export type CrossUniverseTarget =
  | "carte_acces_privilege"
  | "boutique"
  | "checkout"
  | "wallet"
  | "explore"
  | "combos"
  | "last_call"
  | "regions"
  | "alerts"
  | "dashboard";

export function buildForfeoComUrl(
  path = "/",
  params: Record<string, string | number | boolean | null | undefined> = {}
) {
  const url = new URL(path, FORFEO_COM_URL);
  url.searchParams.set("from", "forfeo_explore");
  url.searchParams.set("return_url", `${FORFEO_EXPLORE_URL}/`);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && String(value).trim() !== "") {
      url.searchParams.set(key, String(value));
    }
  });
  return url.toString();
}

export function buildExploreUrl(
  path = "/",
  params: Record<string, string | number | boolean | null | undefined> = {}
) {
  const url = new URL(path, FORFEO_EXPLORE_URL);
  url.searchParams.set("from", "forfeo_com");
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && String(value).trim() !== "") {
      url.searchParams.set(key, String(value));
    }
  });
  return url.toString();
}

export async function trackCrossUniverseEvent(payload: {
  sourceSite: "forfeo_explore" | "forfeo_com";
  targetSite: "forfeo_explore" | "forfeo_com";
  source?: CrossUniverseSource;
  target?: CrossUniverseTarget;
  url?: string;
  label?: string;
  metadata?: Record<string, unknown>;
}) {
  try {
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
    if (!supabaseUrl || !anonKey) return { ok: false, skipped: true };

    const response = await fetch(`${supabaseUrl}/functions/v1/cross-universe-event`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        apikey: anonKey,
        Authorization: `Bearer ${anonKey}`,
      },
      body: JSON.stringify(payload),
    });

    return await response.json().catch(() => ({ ok: response.ok }));
  } catch {
    return { ok: false, skipped: true };
  }
}
